import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/forex/Line-20.svg")